import { useTranslation } from "../../hooks/useTranslation";
import { Title } from "../../components/ui/title";
import { Tile } from "../../components/ui/tile";
import { WorkExperience } from "./content/model";
import { useLanguage } from "../../hooks/useLanguage";
import { useLocation, LOCATIONS } from "../../hooks/useLocation";

import styles from "./index.module.scss";

import frenchJson from './content/fr.json';
import englishJson from './content/en.json';

interface ExperienceProps {
    id?: string;
}

export const Experience = ({ id }: ExperienceProps) => {
    const { t } = useTranslation();
    const { language } = useLanguage();
    const { setLocation } = useLocation();

    const content: WorkExperience[] = language === 'fr' ? (frenchJson as WorkExperience[]) : (englishJson as WorkExperience[]);

    // Fonction pour parser la location et retourner le code pays
    const parseLocation = (location: string): LOCATIONS | null => {
        if (/france/i.test(location)) return LOCATIONS.FRANCE;
        if (/canada/i.test(location)) return LOCATIONS.CANADA;
        if (/worldwide/i.test(location)) return LOCATIONS.WORLDWIDE;
        return null;
    };

    return (
        <div className={styles.experience} id={id}>
            <Title>{t("header.experiences")}</Title>
            <div className={styles.tiles}>
                {content.map((experience, index) => (
                    <Tile
                        key={index}
                        title={experience.title}
                        description={experience.company}
                        subDescription={experience.location}
                        date={experience.date}
                        onMouseEnter={() => {
                            const loc = parseLocation(experience.location);
                            if (loc) setLocation(loc);
                        }}
                        onMouseLeave={() => setLocation(null)}
                    />
                ))}
            </div>
        </div>
    );
}